import {
  LIST_REPORT1,
  LIST_REPORT1_SUCCESS,
  LIST_REPORT1_CLEAN,
  LIST_REPORT1_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const Report1List = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT1:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT1_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT1_CLEAN:
      state = initialState
      break
    case LIST_REPORT1_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Report1List
